export const CMS_FIELD_USAGE = {
  main_hero_en_line1: "메인 홈페이지 > Hero > 메인 영문 제목",
  main_hero_en_line2_before: "메인 홈페이지 > Hero > 영문 2줄 앞",
  main_hero_en_line2_highlight: "메인 홈페이지 > Hero > 영문 강조 문구",
  main_hero_kr_line1: "메인 홈페이지 > Hero > 한글 제목",
  main_hero_kr_line2_highlight: "메인 홈페이지 > Hero > 한글 강조 문구",
  main_hero_kr_line2_after: "메인 홈페이지 > Hero > 한글 강조 뒤",
  main_hero_en_tagline: "메인 홈페이지 > Hero > 영문 태그라인",
  main_hero_kr_tagline: "메인 홈페이지 > Hero > 한글 태그라인",
  main_hero_en_cta_lead: "메인 홈페이지 > Hero > 영문 CTA 리드",
  main_hero_en_cta_label: "메인 홈페이지 > Hero > 영문 CTA 버튼",
  main_hero_kr_cta_lead: "메인 홈페이지 > Hero > 한글 CTA 리드",
  main_hero_kr_cta_label: "메인 홈페이지 > Hero > 한글 CTA 버튼",
  main_hero_cta_url: "메인 홈페이지 > Hero > CTA 링크",
  about_title: "메인 홈 `/` About 제목 · 회사소개 `/about` 제목",
  about_body: "메인 홈 `/` About 본문 · 회사소개 `/about` 본문",
  automation_eyebrow: "메인 홈페이지 > Automation > 상단 라벨",
  automation_title: "메인 홈페이지 > Automation > 제목",
  automation_description: "메인 홈페이지 > Automation > 설명",
  ai_platform_title: "메인 홈페이지 > AI Platform > 제목",
  ai_platform_body: "메인 홈페이지 > AI Platform > 설명",
  contact_eyebrow: "메인 홈페이지 > Contact > 상단 라벨",
  contact_title: "메인 홈페이지 > Contact > 제목",
  contact_description: "메인 홈페이지 > Contact > 설명",
  company_name: "사이트 Footer > 회사명",
  company_ceo: "사이트 Footer > 대표자",
  company_business_no: "사이트 Footer > 사업자등록번호",
  company_email: "사이트 Footer · 문의 영역 > 대표 이메일",
  company_phone: "사이트 Footer > 대표 전화번호",
  company_address: "사이트 Footer > 회사 주소",
  kakao_channel_url: "사이트 Footer · 카카오 버튼 > 채널 URL",
  footer_copyright: "사이트 Footer > 저작권 문구",
  site_title: "검색결과 · 브라우저 탭 제목",
  seo_description: "검색결과 스니펫 > Meta Description",
  seo_keywords: "검색엔진 키워드 (메타)",
  seo_og_title: "SNS 공유 카드 > 제목",
  seo_og_description: "SNS 공유 카드 > 설명",
  seo_og_url: "SNS 공유 카드 > URL",
  seo_canonical_url: "검색결과 · canonical URL",
};

export function fieldUsage(key) {
  return CMS_FIELD_USAGE[key] ? `사용 위치: ${CMS_FIELD_USAGE[key]}` : "";
}
